/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder, PlaceholderText } from 'sarsaparilla';
import './FindACampsiteSectionListPlaceholder.scss';

const ROW_COUNT = 3;

export default function FindACampsiteSectionListPlaceholder() {
    return (
        <div className="find-a-campsite-section-list-placeholder" aria-hidden="true">
            {Array.from({ length: ROW_COUNT }).map((_, index) => (
                <div
                    key={`find-a-campsite-list-placeholder-row-${index}`}
                    className="find-a-campsite-section-list-placeholder-row"
                >
                    <div className="find-a-campsite-section-list-placeholder-thumb">
                        <Placeholder height="135px" width="100px" />
                    </div>
                    <div className="find-a-campsite-section-list-placeholder-main">
                        <Placeholder height="20px" width="72%" />
                        <Placeholder height="24px" width="112px" borderRadius="999px" />
                        <Placeholder height="16px" width="38%" />
                        <PlaceholderText fontSize={16} lineHeight={20} lines={2} />
                        <div className="find-a-campsite-section-list-placeholder-cta-row">
                            <Placeholder height="18px" width="28%" />
                            <Placeholder height="32px" width="104px" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
